// convex/lib/config/domains/subscriptions.ts

import { validatorSubscriptionPlan } from "../../../system/plans";
import { validatorCompanySubscription } from "../../../companies/subscriptions";
import { validatorCompany } from "../../../companies";
import { validatorUsers } from "../../../system/users";
import type { DomainGroup, TableScope } from "../types";

export const subscriptionsDomain: DomainGroup = {
  id: "subscriptions",
  name: "Suscripciones",
  description: "Gestión de planes y suscripciones",
  icon: "CreditCard",
  order: 2,
  status: "active",
  modules: [
    {
      id: "subscription_plans",
      name: "Planes",
      description: "Gestión de planes de suscripción",
      icon: "CreditCard",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/super/plans"],
      navigation: {
        showInNav: true,
        contexts: ["super"],
        navOrder: 5,
        status: "active",
      },
      tables: [
        {
          tableName: "subscription_plans",
          schema: validatorSubscriptionPlan,
          scope: "company" as TableScope,
          relations: [
            {
              key: "companyId",
              sourceField: "companyId",
              schema: validatorCompany,
              tableName: "companies",
            },
          ],
          searchFields: ["name", "description"],
          hasStatusIndex: true,
        },
      ],
      readOnlyTables: [],
    },
    {
      id: "company_subscriptions",
      name: "Suscripción",
      description: "Gestión de suscripción y planes",
      icon: "Calendar",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/settings/subscription", "/super/subscriptions"],
      navigation: {
        showInNav: true,
        contexts: ["settings", "super"],
        navOrder: 14,
        status: "active",
      },
      tables: [
        {
          tableName: "company_subscriptions",
          schema: validatorCompanySubscription,
          scope: "company" as TableScope,
          relations: [
            {
              key: "company",
              sourceField: "companyId",
              schema: validatorCompany,
              tableName: "companies",
            },
            {
              key: "plan",
              sourceField: "planId",
              schema: validatorSubscriptionPlan,
              tableName: "subscription_plans",
            },
            {
              key: "lastUpdatedBy",
              sourceField: "internalControl.updatedBy",
              schema: validatorUsers,
              tableName: "users",
            },
          ],
          searchFields: ["status"],
          hasStatusIndex: true,
        },
      ],
      readOnlyTables: [
        { tableName: "companies" },
        { tableName: "subscription_plans" },
        { tableName: "branches" },
      ],
    },
  ],
};
